import { useContext, useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import CompGroupDialogContext from 'pages/Valuations/components/CompGroups/components/common/CompGroupDialogContext';
import FormLabelCompGroup from 'pages/Valuations/components/CompGroups/components/common/FormLabelCompGroup';
import { FIRM_COMP_GROUPS, SCALAR_COMP_GROUPS } from 'pages/Valuations/util/constants';
import { HandleSelectCompGroup, PublicCompsListProps } from './PublicCompsList.props';
import { publicCompsListClasses, PublicCompsListRoot } from './PublicCompsList.styles';
import { CompGroupListCreateExtended } from '../common/types';

const PublicCompsList = ({ setCompGroupId }: PublicCompsListProps) => {
  const { compGroupList, compGroupSelected, setCompaniesToDelete, setCompGroupToDelete } =
    useContext(CompGroupDialogContext);

  const handleOnSelectCompGroup = (value: HandleSelectCompGroup) => {
    const compGroupId = value ? value.id : -1;
    setCompaniesToDelete([]);
    setCompGroupToDelete(null);
    setCompGroupId(compGroupId);
  };

  const [globalComps, setGlobalComps] = useState<Partial<CompGroupListCreateExtended>[]>([]);
  const [firmComps, setFirmComps] = useState<Partial<CompGroupListCreateExtended>[]>([]);
  // Reorder comps to put the Firm comps first in the dropdown
  const reorderComps = firmComps?.concat(globalComps);

  useEffect(() => {
    setGlobalComps(compGroupList?.filter(compGroup => compGroup.is_global));
    setFirmComps(compGroupList?.filter(compGroup => !compGroup.is_global));
  }, [compGroupList]);

  const options = reorderComps || compGroupList;
  const selectedValue = options.find(option => option.id === compGroupSelected?.id) || null;

  return (
    <PublicCompsListRoot>
      <FormLabelCompGroup title="Comp Group:"></FormLabelCompGroup>
      <Autocomplete
        id="comp-groups-autocomplete"
        value={selectedValue}
        classes={{
          option: publicCompsListClasses.option,
          groupLabel: publicCompsListClasses.groupLabel,
        }}
        // getOptionSelected={(option, value) => option.id === value.id}
        getOptionLabel={option => option.name ?? ''}
        options={options}
        groupBy={option => (option.is_global ? SCALAR_COMP_GROUPS : FIRM_COMP_GROUPS)}
        style={{
          marginRight: '1rem',
        }}
        renderInput={params => <TextField {...params} placeholder="Select Comps" variant="outlined" />}
        onChange={(__event, value) => handleOnSelectCompGroup(value as HandleSelectCompGroup)}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        )}
      />
    </PublicCompsListRoot>
  );
};

export default PublicCompsList;
